import { render, staticRenderFns } from "./TagCard.vue?vue&type=template&id=0ce223b9"
import script from "./TagCard.vue?vue&type=script&lang=js"
export * from "./TagCard.vue?vue&type=script&lang=js"
import style0 from "./TagCard.vue?vue&type=style&index=0&id=0ce223b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports